/* Encabezado de video: carga la versión horizontal o la vertical según el ancho de pantalla,
   la reproduce en bucle (o una sola vez, según el ajuste "Repetir") y la pausa fuera de pantalla.
   Se elige la fuente antes de cargar nada para no descargar los dos videos. */
(() => {
  const MOBILE = '(max-width: 749px)';

  const setup = (video) => {
    video.dataset.ready = 'true';

    const wanted = () => (window.matchMedia(MOBILE).matches ? video.dataset.srcMobile : video.dataset.srcDesktop);

    const load = () => {
      const src = wanted();
      if (!src) return;
      if (video.dataset.loaded === src) {
        // ya cargado: si está en bucle o no ha terminado, retomar al volver a la pantalla
        if (video.paused && !video.ended) {
          const retoma = video.play();
          if (retoma) retoma.catch(() => {});
        }
        return;
      }
      video.dataset.loaded = src;
      video.src = src;
      video.load();
      const play = video.play();
      if (play) play.catch(() => {}); // si el navegador bloquea la reproducción, queda el póster
    };

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; // se queda el póster

    const observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) load();
        else if (!video.ended) video.pause();
      }
    }, { threshold: 0 });
    observer.observe(video);

    // al cambiar de horizontal a vertical (girar el teléfono) se carga la otra versión
    window.matchMedia(MOBILE).addEventListener('change', () => {
      video.dataset.loaded = '';
      load();
    });
  };

  const init = () => document.querySelectorAll('video[data-hero-video]:not([data-ready])').forEach(setup);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
